import React, { useState } from "react";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import Radio from "@material-ui/core/Radio";
// @material-ui/icons
import FiberManualRecord from "@material-ui/icons/FiberManualRecord";
//core components
import styles from "assets/jss/material-dashboard-react/checkboxAdnRadioStyle.js";
import Label from "reactstrap/lib/Label";

const useStyles = makeStyles(styles);

const TSRadio = props => {
  const classes = useStyles();
  const [selectedValue, setSelectedValue] = React.useState(null);

  const [options, setOptions] = useState(
    props.options !== "undefined" ? props.options : []
  );

  return (
    <div>
      <Label>ความเร่งด่วน</Label>
      {options.map(key => (
        <>
          <Label>
            <Radio
              checked={selectedValue === key.value}
              onChange={() => setSelectedValue(key.value)}
              value={key.value}
              name="radio button demo"
              aria-label={key.value}
              icon={<FiberManualRecord className={classes.radioUnchecked} />}
              checkedIcon={
                <FiberManualRecord className={classes.radioChecked} />
              }
              classes={{
                checked: classes.radio
              }}
            />
            <span style={{ paddingRight: "20px" }}> {key.label} </span>
          </Label>
        </>
      ))}

      {/*
      <Radio
        checked={selectedValue === "b"}
        onChange={() => setSelectedValue("b")}
        value="b"
        name="radio button demo"
        aria-label="B"
        icon={<FiberManualRecord className={classes.radioUnchecked} />}
        checkedIcon={<FiberManualRecord className={classes.radioChecked} />}
        classes={{
          checked: classes.radio
        }}
            />
    */}
    </div>
  );
};

export default TSRadio;
